import type { PropsOf } from './utils'
import AnalyticsModuleComponentsSingle from '~/components/Analytics/Module/Components/Single.vue'
import AnalyticsModuleComponentsDouble from '~/components/Analytics/Module/Components/Double.vue'
import AnalyticsModuleComponentsTop from '~/components/Analytics/Module/Components/Top.vue'
import AnalyticsModuleComponentsPyramid from '~/components/Analytics/Module/Components/Pyramid.vue'
import AnalyticsModuleComponentsDistribution from '~/components/Analytics/Module/Components/Distribution.vue'
import AnalyticsModuleComponentsLargeChart from '~/components/Analytics/Module/Components/LargeChart.vue'

export enum DashboardModuleType {
  SINGLE = 'SINGLE',
  DOUBLE = 'DOUBLE',
  TOP = 'TOP',
  PYRAMID = 'PYRAMID',
  DISTRIBUTION = 'DISTRIBUTION',
  LARGE_CHART = 'LARGE_CHART'
}

type ModuleTypeToComponentProps = {
  [DashboardModuleType.SINGLE]: PropsOf<typeof AnalyticsModuleComponentsSingle>
  [DashboardModuleType.DOUBLE]: PropsOf<typeof AnalyticsModuleComponentsDouble>
  [DashboardModuleType.TOP]: PropsOf<typeof AnalyticsModuleComponentsTop>
  [DashboardModuleType.PYRAMID]: PropsOf<
    typeof AnalyticsModuleComponentsPyramid
  >
  [DashboardModuleType.DISTRIBUTION]: PropsOf<
    typeof AnalyticsModuleComponentsDistribution
  >
  [DashboardModuleType.LARGE_CHART]: PropsOf<
    typeof AnalyticsModuleComponentsLargeChart
  >
}

export type ModuleConfig = {
  [K in DashboardModuleType]: {
    moduleType: K
    options: ModuleTypeToComponentProps[K]
  }
}[keyof typeof DashboardModuleType]

type DashboardSectionConfig = {
  titleKey: string
  content: ModuleConfig[]
}

export type DashboardConfig = DashboardSectionConfig[]
